export default "__VITE_ASSET__9d8d6613__"